import React, {useEffect} from "react";
import { useNavigate } from "react-router";
import { useDispatch } from 'react-redux'

const Logout = () => {

    const dispatch = useDispatch();
    const navitage = useNavigate();

    const logout = async () => {
        dispatch({type:"LOGOUT", payload:null})
        localStorage.setItem("user", null);
        navitage("/")
        window.location.reload()
    }

    useEffect(() => {
        logout();
    }, []);

    return (
        <div></div>
    );
}

export default Logout;